export default "__VITE_ASSET__xN_286jL__"